import { AIStartedWritingFrom } from '../types';

export const checkIsWriteMode = (startedWritingFrom: AIStartedWritingFrom) => {
  return [AIStartedWritingFrom.SCRATCH, AIStartedWritingFrom.NEW_LINE].includes(
    startedWritingFrom
  );
};
